<div class="p-grid">
    <p-table class="p-col-12"  #dt [columns]="contentCol" [value]="contents" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <ng-template pTemplate="caption">
            <div style="text-align: right">
                <div class="ui-inputgroup recherche" >
                    <span class="ui-inputgroup-addon">Rechercher :</span>
                    <input type="text" pInputText size="37" placeholder="Filtre globale" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto; min-height:35px;">
                </div>
            </div>
        </ng-template>
        
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of contentCol" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ></p-sortIcon>
                </th>
                
                <th style="width: 125px; ">Prendre</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-moderation let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{moderation[col.field]}}
                </td>
                <td align="center"> <button pButton type="button"  icon="pi pi-id-card"  style="width: 55px;" [routerLink]="['/pages/traitement']"></button> </td>
            </tr>
        </ng-template>
    </p-table>
</div>
